const ENVPATH = {
    DASHBOARD_STAGING: '/dashboard'
}

export default ENVPATH;